import { ControlsToggleExtraContent, LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

export const components: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/02/20/principle/25-absorption.svg`,
        },
      },
    },
  },
];

export const extraContent: ControlsToggleExtraContent = [
  {
    type: "audioButton",
    options: {
      url: `${config.ASSETS_URL}/02/20/principle/binaural-25-absorption.wav`,
      text: "Binaural",
      icon: "cis-volume-high",
      theme: "secondary",
      shape: "round",
      styles: {
        marginTop: "20px",
      },
    },
  },
  {
    type: "audioButton",
    options: {
      url: `${config.ASSETS_URL}/02/20/principle/right-only-25-absorption.wav`,
      text: "Right only",
      icon: "cis-volume-high",
      theme: "secondary",
      shape: "round",
      styles: {
        marginTop: "20px",
      },
    },
  },
  {
    type: "audioButton",
    options: {
      url: `${config.ASSETS_URL}/02/20/principle/left-only-25-absorption.wav`,
      text: "Left only",
      icon: "cis-volume-high",
      theme: "secondary",
      shape: "round",
      styles: {
        marginTop: "20px",
      },
    },
  },
];
